import React, { useEffect, useRef, useState } from "react"
import { Grid, useMediaQuery, useTheme } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Scrollbar, Autoplay } from "swiper/modules"
import CustomArrows from "../../components/custom-arrows/custom-arrows.component"
import Logo from "../../assets/icons/why-use-logo.svg"

import * as S from "./why-use.styles"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/scrollbar"
import LogosSlider from "../../components/logos-slider/logos-slider.component"

const WhyUse = ({
  title,
  logo,
  features,
  button,
  bottomTitle,
  donors,
  nonprofits,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(1080))
  const [selectedReviews, setSelectedReviews] = useState("donors")
  const [progressIndex, setProgressIndex] = useState(0)
  const progressCircle = useRef(null)
  // const progressContent = useRef(null)
  const sliderRef = useRef(null)
  const logosSlider = useRef(null)
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle?.current?.style?.setProperty("--progress", 1 - progress)
    // progressContent.current.textContent = `${Math.ceil(time / 1000)}s`
  }

  // const handleGotoSlide = index => {
  //   sliderRef.current.swiper.slideTo(index)
  // }

  useEffect(() => {
    // console.log("progressIndex :>> ", progressIndex)
    logosSlider.current.swiper.slideTo(progressIndex)
    sliderRef.current.swiper.slideTo(progressIndex)
  }, [progressIndex])

  return (
    <S.Section>
      <S.Wrapper>
        <S.TitleContainer>
          <S.Title>{title} </S.Title>
          <Logo />
          <S.Title>?</S.Title>

          {/* <S.Logo img={logo} /> */}
        </S.TitleContainer>
        <Grid container spacing={3}>
          {features?.map(({ icon, title, description }, index) => (
            <Grid item xs={12} sm={6} key={`${title}-${index}`}>
              <S.CardContainer
                className={index === 0 || index === 3 ? "other-color" : ""}
              >
                <S.Icon img={icon} />
                <S.CardTitle>{title}</S.CardTitle>
                <S.Description>{description}</S.Description>
              </S.CardContainer>
            </Grid>
          ))}
        </Grid>
        {!isMobile && (
          <S.ButtonContainer>
            <CustomButton href={button?.url} className="darkBorder">
              {button?.title}
            </CustomButton>
          </S.ButtonContainer>
        )}

        <S.BottomTitle>{bottomTitle}</S.BottomTitle>
        <S.ButtonContainer>
          <S.OptionButton
            onClick={() => setSelectedReviews("donors")}
            className={selectedReviews === "donors" ? "selected" : ""}
          >
            Donors
          </S.OptionButton>
          <S.OptionButton
            onClick={() => setSelectedReviews("nonprofits")}
            className={selectedReviews === "nonprofits" ? "selected" : ""}
          >
            Nonprofits
          </S.OptionButton>
        </S.ButtonContainer>
        <S.ButtonsContainer>
          <LogosSlider
            items={selectedReviews === "donors" ? donors : nonprofits}
            progressIndex={progressIndex}
            setProgressIndex={setProgressIndex}
            // handleGotoSlide={handleGotoSlide}
            progressCircle={progressCircle}
            logosSlider={logosSlider}
          />
          {/* <S.LogosSlider>
            <Swiper
              // modules={[Navigation]}
              modules={[Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              // spaceBetween={8}
              spaceBetween={8}
              slidesPerView={1}
              ref={logosSlider}
              // loop
            >
              {(selectedReviews === "donors" ? donors : nonprofits).map(
                ({ logo, description }, index) => (
                  <SwiperSlide key={`${description}-${index}`}>
                    <S.Circle onClick={() => setProgressIndex(index)}>
                      <div className="autoplay-progress" slot="container-end">
                        {index === progressIndex && (
                          <svg viewBox="0 0 48 48" ref={progressCircle}>
                            <circle cx="24" cy="24" r="20"></circle>
                          </svg>
                        )}
                        <S.LogoContainer>
                          <S.LogoSwiper img={logo} />
                        </S.LogoContainer>
                      </div>
                    </S.Circle>
                  </SwiperSlide>
                ),
              )}
            </Swiper>
          </S.LogosSlider> */}
          {/* <S.LogosWrapper>
              {(selectedReviews === "donors" ? donors : nonprofits).map(
                ({ logo, description }, index) => (
                  <S.Circle key={`${description}-${index}`}>
                    <div className="autoplay-progress" slot="container-end">
                      {index === progressIndex && (
                        <svg viewBox="0 0 48 48" ref={progressCircle}>
                          <circle cx="24" cy="24" r="20"></circle>
                        </svg>
                      )}
                      <S.LogoContainer>
                        <S.LogoSwiper img={logo} />
                      </S.LogoContainer>
                    </div>
                  </S.Circle>
                ),
              )}
            </S.LogosWrapper> */}
          {!isMobile && (
            <div>
              <CustomArrows
                leftArrow="prevInfoSlider"
                rightArrow="nextInfoSlider"
                number={progressIndex}
                length={
                  selectedReviews === "donors"
                    ? donors.length
                    : nonprofits.length
                }
              />
            </div>
          )}
        </S.ButtonsContainer>
        <S.SwiperContainer>
          <Swiper
            slidesPerView={1}
            modules={[Navigation, Scrollbar, Autoplay]}
            navigation={{
              prevEl: ".prevInfoSlider",
              nextEl: ".nextInfoSlider",
            }}
            scrollbar={true}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            autoHeight={isMobile}
            onAutoplayTimeLeft={onAutoplayTimeLeft}
            onSlideChange={() =>
              setProgressIndex(sliderRef?.current?.swiper?.activeIndex)
            }
            ref={sliderRef}
          >
            {(selectedReviews === "donors" ? donors : nonprofits).map(
              ({ name, position, review }, index) => (
                <SwiperSlide key={`slide-${index}`}>
                  <S.InfoContainer>
                    <S.Name>{name}</S.Name>
                    <S.Position>{position}</S.Position>
                    <S.Review>{review}</S.Review>
                  </S.InfoContainer>
                </SwiperSlide>
              ),
            )}
          </Swiper>
        </S.SwiperContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default WhyUse
